import { useState } from 'react'
import { Plus, X } from 'lucide-react'

type Props = {
  onAdd: (name: string) => void
}

export function ImpulseBuyInput({ onAdd }: Props) {
  const [open,  setOpen]  = useState(false)
  const [value, setValue] = useState('')

  function handleSubmit() {
    const trimmed = value.trim()
    if (trimmed.length === 0) return
    onAdd(trimmed)
    setValue('')
    setOpen(false)
  }

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        className="w-full mb-6 rounded-[14px] border border-dashed border-[#D4C4A8] bg-paper px-[14px] py-3 flex items-center gap-[10px] text-left"
      >
        <div className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-[7px] bg-[#FBE8DB]">
          <Plus className="h-3 w-3 text-terracotta" strokeWidth={1.8} />
        </div>
        <span className="font-serif text-[13px] italic text-ink-muted flex-1">
          Grabbed something extra?
        </span>
      </button>
    )
  }

  return (
    <div className="mb-6 rounded-[14px] border border-border-sand bg-paper p-[14px]">
      <div className="flex items-center gap-2 mb-2">
        <div className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-[7px] bg-[#FBE8DB]">
          <Plus className="h-3 w-3 text-terracotta" strokeWidth={1.8} />
        </div>
        <span className="font-serif text-[13px] italic text-ink-muted">
          What did you add?
        </span>
        <div className="flex-1" />
        <button
          onClick={() => { setOpen(false); setValue('') }}
          className="text-ink-muted"
        >
          <X className="h-4 w-4" strokeWidth={1.6} />
        </button>
      </div>
      <div className="flex gap-2">
        <input
          type="text"
          autoFocus
          value={value}
          onChange={e => setValue(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          placeholder="e.g. Avocados"
          className="flex-1 rounded-[10px] border border-border-sand bg-cream px-3 py-2 font-serif text-[14px] italic text-ink placeholder:text-ink-muted focus:outline-none focus:border-forest"
        />
        <button
          onClick={handleSubmit}
          disabled={value.trim().length === 0}
          className="rounded-[10px] bg-forest px-4 py-2 text-[12px] font-bold text-forest-ink disabled:opacity-50"
        >
          Add
        </button>
      </div>
    </div>
  )
}
